const state = {
  stats: undefined,
  publicDisplayStats: undefined
};

export default state;
